import { useHandleActionItem } from '@/components/hooks/useHandleActionItem';
import { useCoreContext } from '@/core';
import { RolesColumn } from '@/domain/entities/roles';
import { EllipsisOutlined } from '@ant-design/icons';
import { Button, Dropdown, Tooltip, Typography } from 'antd';
import type { MenuProps } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { TimeCell } from '../../../components/TimeCell';
import useViewModel from '../viewmodels/delete';

export const RolesTableColumns = () => {
  const { handleClickEdit, handleClickDuplicate, showConfirmDelete } = useHandleActionItem();
  const { loading, error, actionDelete } = useViewModel();
  const { actionGetAll } = useCoreContext();

  const deleteContent = <p>Are you sure to delete this item?</p>;

  const propsDelete = {
    content: deleteContent,
    loading: loading,
    error: error,
    actionDelete: actionDelete,
    recordId: '',
    refresh: actionGetAll,
  };

  const getActionMenuItems = (record: RolesColumn): MenuProps['items'] => [
    {
      key: 'edit',
      label: 'Edit',
      onClick: () => handleClickEdit(record),
    },
    {
      key: 'duplicate',
      label: 'Duplicate',
      onClick: () => handleClickDuplicate(record),
    },
    {
      key: 'delete',
      label: 'Delete',
      danger: true,
      onClick: () => {
        showConfirmDelete({ ...propsDelete, recordId: record.id ?? '' });
      },
    },
  ];

  const tableColumns: ColumnsType<RolesColumn> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'status',
      render: (value: boolean) => {
        if (value === true) {
          return <Typography.Text type='success'>Active</Typography.Text>;
        }
        return <Typography.Text disabled>Deactivated</Typography.Text>;
      },
    },
    {
      title: 'Last update at',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (record) => {
        return <TimeCell value={record} />;
      },
    },
    {
      title: 'Create at',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (record) => {
        return <TimeCell value={record} />;
      },
    },
    {
      title: 'Action',
      width: '4rem',
      key: 'action',
      render: (_value, record) => {
        return (
          <div className='actions flex justify-center'>
            <Tooltip title='Actions'>
              <Dropdown menu={{ items: getActionMenuItems(record) }} trigger={['click']}>
                <Button
                  size='small'
                  type='text'
                  className='!flex !h-9 !w-9 !items-center !justify-center !rounded-full !border !border-solid !border-[#d9d9d9] !text-[#6b7280] hover:!border-[#1677ff] hover:!text-[#1677ff]'
                  icon={<EllipsisOutlined style={{ fontSize: 18 }} />}
                />
              </Dropdown>
            </Tooltip>
          </div>
        );
      },
      fixed: 'right',
    },
  ];

  return tableColumns;
};
